import Account from './account'
import Banks from './banks'
import Cities from './cities'
import Files from './files'
import Provinces from './provinces'
import Settings from './settings'
import Transports from './transports'

export default (store) => ({
  account: new Account(store),
  banks: new Banks(store),
  cities: new Cities(store),
  files: new Files(store),
  provinces: new Provinces(store),
  settings: new Settings(store),
  transports: new Transports(store)
})
